export default __webpack_public_path__ + "static/media/314.35ea9d4d.jpg";